/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the HourlyDataPoint interface.
 */
export function instanceOfHourlyDataPoint(value) {
    if (!('generations' in value) || value['generations'] === undefined)
        return false;
    if (!('hour' in value) || value['hour'] === undefined)
        return false;
    if (!('sessionInits' in value) || value['sessionInits'] === undefined)
        return false;
    return true;
}
export function HourlyDataPointFromJSON(json) {
    return HourlyDataPointFromJSONTyped(json, false);
}
export function HourlyDataPointFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'generations': json['generations'],
        'hour': json['hour'],
        'sessionInits': json['session_inits'],
    };
}
export function HourlyDataPointToJSON(json) {
    return HourlyDataPointToJSONTyped(json, false);
}
export function HourlyDataPointToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'generations': value['generations'],
        'hour': value['hour'],
        'session_inits': value['sessionInits'],
    };
}
